<template>
  <report-page
    :title="name"
    :data-to-send="dataToSend"
    :buttons-disabled="buttonsDisabled"
    :history-filter="historyFilter"
    :selectedWorkspaceUUID="selectedWorkspace"
  >
    <template v-slot:reportForm>
      <report-field :field-name="$tc('Workspace', 1)">
        <treeselect
          v-model="selectedWorkspace"
          :options="workspaceOptions"
          :disabled="
            !hasPermissionToCreateExport ||
              workspaceSelectionDisabled ||
              !userHasManagementPermission('workspace', 'list')
          "
          disableFuzzyMatching
        />
      </report-field>
      <report-field :field-name="$tc(reportParameters[0].label, 1)">
        <treeselect
          v-model="reportParameters[0].value"
          :options="centralOfficeOptions"
          :load-options="loadCentralOfficeOptions"
          :multiple="true"
          value-consists-of="LEAF_PRIORITY"
          :default-expand-level="1"
          :disabled="
            !hasPermissionToCreateExport ||
              opticalEquipmentFieldsDisabled ||
              !userHasPermissionToList('technical_local')
          "
          disableFuzzyMatching
        />
      </report-field>
    </template>
  </report-page>
</template>

<script>
import ReportPage from "../ReportPage";
import ReportField from "../ReportField";
import { homeReportPageMixin } from "@/mixins/homeReportPageMixin";

export default {
  name: "CentralOfficeTrayPlanReport",

  components: {
    ReportField,
    ReportPage
  },

  mixins: [homeReportPageMixin],

  props: {
    name: {
      type: String,
      required: true
    },
    version: {
      type: String
    }
  },

  data() {
    return {
      reportParameters: [
        {
          label: "CentralOffice",
          key: "central_office",
          type: "text",
          value: []
        }
      ],

      centralOfficeOptions: null,

      historyFilter: "rack_plan"
    };
  },

  computed: {
    opticalEquipmentFieldsDisabled() {
      return this.selectedWorkspace === undefined;
    },
    buttonsDisabled() {
      return this.reportParameters[0].value === undefined;
    },
    dataToSend() {
      let dataToSend = {
        type: this.historyFilter,
        version: this.version,
        objects: {
          workspace_uuid: this.selectedWorkspace
        }
      };
      dataToSend.objects.object = this.fillArrayOfObjectsToSend(
        this.reportParameters[0].value,
        "technical_local"
      );
      return dataToSend;
    }
  },

  watch: {
    selectedWorkspace() {
      this.resetReportParameterValues(this.reportParameters, 0);
      this.centralOfficeOptions = null;
    }
  },

  mounted() {
    this.setWorkspaceField();
  },

  methods: {
    loadCentralOfficeOptions({ callback }) {
      if (this.selectedWorkspace) {
        this.getWorkspaceTechnicalSitesWithLocals().then(
          technicalSitesWithLocals => {
            this.centralOfficeOptions = this.getWorkspaceCentralOfficesOptions(
              technicalSitesWithLocals
            );
            this.centralOfficeOptions = this.includeInAllOption(
              this.centralOfficeOptions
            );
            callback();
          }
        );
      } else {
        callback();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/ReportsPages/COTrayPlan.vue